import React, { memo, useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from 'store';
import { selectAuthUser } from 'store/auth';
import { DialogSendWhatsApp, FormModel } from 'components/dialog-send-whats-app';
import { useCurrentUser } from 'components/hooks';
import {
  selectPatientWhatsAppMessageCurrent,
  MessageItem,
  patientWhatsAppMessagesActions,
  actionPatientWhatsAppMessagesSendMessage,
} from 'store/patient-whats-app-messages';
interface ViewProps {
  currentMessage: MessageItem;
}

const View = memo<ViewProps>(({ currentMessage }) => {
  const dispatch = useAppDispatch();
  const currentEmployee = useCurrentUser();
  const onClose = useCallback(() => {
    dispatch(patientWhatsAppMessagesActions.remove(currentMessage));
  }, [currentMessage, dispatch]);

  const templatePayload = useMemo(() => {
    return {
      currentEmployee: currentEmployee,
      ...currentMessage.templatePayload,
    };
  }, [currentMessage.templatePayload, currentEmployee]);

  const onSubmit = useCallback(
    async (formData: FormModel) => {
      const variables = formData.variables.map((v) => v.value);

      dispatch(
        actionPatientWhatsAppMessagesSendMessage({
          item: currentMessage,
          messageForm: { ...formData, variables },
        }),
      );
    },
    [currentMessage, dispatch],
  );

  const initData = useMemo(() => {
    return {
      toPhoneNumber: currentMessage.formData.toPhoneNumber ?? undefined,
      whatsAppContentID: currentMessage.formData.whatsAppContentID ?? undefined,
    };
  }, [currentMessage.formData]);

  return (
    <DialogSendWhatsApp
      key={currentMessage.uid}
      isLoading={currentMessage._isLoading}
      onClose={onClose}
      initData={initData}
      onSubmit={onSubmit}
      templatesPayload={templatePayload}
    />
  );
});

interface Props {}
export const AppPatientWhatsAppMessagesProvider = memo<Props>(() => {
  const user = useAppSelector(selectAuthUser);
  const currentItem = useAppSelector(selectPatientWhatsAppMessageCurrent);
  return <>{user && currentItem && <View currentMessage={currentItem} />}</>;
});
